import { z } from 'zod';
/**
 * Email address contract.
 *
 * Normalization rules:
 *   - Trimmed
 *   - Lowercased (applied via .transform after validation)
 *
 * Use this schema at HTTP boundaries (request validation) and for form
 * inputs. Aggregates that take an Email as a Value Object may layer
 * additional domain rules on top (e.g. disallow disposable domains).
 */
export const EmailSchema = z
    .string()
    .trim()
    .min(1, 'Email is required')
    .email('Invalid email format')
    .transform((value) => value.toLowerCase());
//# sourceMappingURL=email.schema.js.map